import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {AssetService} from "../../services/AssetService";
import {ReportAssetsModelBase} from "./ReportAssetsModelBase";

export class ReportAssetChildrenModel extends ReportAssetsModelBase {
    static $inject = ['$q','FileSaver','Blob','AssetService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public assetService:AssetService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        super();
        this.getCount();
    }
    getReport(): ng.IPromise<any>{
        return this.assetService.getAssetChildrenReport(this.name).then((data) => {
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'assetchildren.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("get assets report err:"+exc);
            });
        return this.$q.when();
    }
    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.assetService.getAssetChildrenReportCount(this.name)
        .then((data)=>{
            this.totalCount = data;
        }).catch((exc)=>{
            this.notifyService.notify("Exception in getCount-"+exc);
        });
    }
}
